import React, { useMemo, lazy, Suspense } from "react";
import { useTranslation } from "react-i18next";

import { useTypedSelector } from "../../../../redux/store";
import useActiveTab from "../../../../hooks/useActiveTab";
import { hasAccess } from "../../../../access";
import { TabOptions } from "../../../../types";
import BasicPageLayout from "../../../../components/BasicPageLayout";
import { SuspenseLoader, SideTab } from "../../../../components/common";

import { TabKeys, TabAccessNames, mainPath } from "./constants/access";

const LazyExecutorOrdersReport = lazy<React.FC<DetailsReportsPage.Props>>(
	async () => {
		const elem = await import(
			"./tabs/ExecutorOrdersReport" /* webpackChunkName: "reports-details-reports-page-executor-orders-report" */
		);
		return { default: elem.default };
	},
);

/** Отчёты → Детализация. */
const DetailsReportsPage: React.FC = () => {
	const { t } = useTranslation();

	const personalRole = useTypedSelector(
		(state) => state.account.personalRole,
	);

	const tabs: TabOptions.Array = useMemo(
		() =>
			[
				{
					key: TabKeys.EXECUTOR_ORDERS_REPORT,
					label: t(`${mainPath}.executorOrdersReport.title`),
					value: {
						render: () => (
							<Suspense fallback={<SuspenseLoader />}>
								<LazyExecutorOrdersReport
									headerTitle={t(
										`${mainPath}.executorOrdersReport.title`,
									)}
								/>
							</Suspense>
						),
					},
					accessName: TabAccessNames[TabKeys.EXECUTOR_ORDERS_REPORT],
				},
			].filter((btn) => hasAccess(btn.accessName, personalRole)),
		[t, personalRole],
	);

	const { activeKey, activeTab, setActiveKey } = useActiveTab(tabs);

	return (
		<BasicPageLayout
			navigation={
				<SideTab
					value={activeKey}
					onChange={(newActive) => setActiveKey(newActive)}
					options={tabs}
					variant="vertical"
				/>
			}
			content={activeTab.value.render()}
		/>
	);
};

declare namespace DetailsReportsPage {
	interface Props {
		headerTitle: string;
		general?: boolean;
	}
}

export default DetailsReportsPage;
